import { Component, Input, OnInit } from "@angular/core";
import {
  DEEventEmitterBo,
} from "./client-employee-dynamicform.model";
import { GlobalComponent } from "src/app/global/global.component";
import { JwtHelper } from "angular2-jwt";
@Component({
  selector: "app-client-employee-dynamicform",
  templateUrl: "./client-employee-dynamicform.component.html",
  styleUrls: ["./client-employee-dynamicform.component.scss"],
})
export class ClientEmployeeDynamicFormComponent implements OnInit {
  CEEditList: boolean = false;
  @Input() DynamicFormRelation;
  isListorEditView: DEEventEmitterBo = new DEEventEmitterBo();
  constructor(public global: GlobalComponent,public JwtHelper:JwtHelper) { }
  ngOnInit(): void {
    console.log(this.global.OnboardType,"this.global.OnboardType");
    if (this.global.OnboardType == "CLIENT") {
      let decodedToken = this.JwtHelper.decodeToken(this.global.authtoken);
      console.log(decodedToken,"decodetoken")
      this.global.LoginEntityId=decodedToken.LOGINENTITYID;
      let value = {
        Id:this.global.LoginEntityId,
        Dynamictype: "Client",
        dynamicClientType:this.DynamicFormRelation.dynamicClientType
      }
      this.isListorEditView.details = value;
      console.log("if",value)
    }
    else {
      this.isListorEditView.details = this.DynamicFormRelation;
      console.log("else",)

    }
    console.log(this.isListorEditView,"this.isListorEditView")
  }
  EmitChildComponent(event: DEEventEmitterBo) {
    this.CEEditList = event.isCreate;
    this.isListorEditView = event;
   
  }
}
